"use client";
import React, { useEffect } from "react";
import Header from "./Header";
import Footer from "./Footersection";

const PrivacyPolicy = () => {
  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to top on mount
  }, []);

  return (
    <div className="flex flex-col min-h-screen">
      <Header />

      <main className="flex flex-col items-center flex-1 p-10 w-full max-w-5xl mx-auto gap-8">
        <h1 className="text-3xl font-bold text-center text-gray-800 mb-6">
          Privacy Policy
        </h1>

        <div className="bg-white rounded-2xl shadow-lg p-8 w-full space-y-6 text-gray-700">
         <p>
  We respect your privacy and are committed to protecting your personal data. 
  This Privacy Policy explains how we collect, use, and safeguard information 
  when you visit{" "}
  <a
    href="https://onestopweddingdresses.com"
    target="_blank"
    rel="noopener noreferrer"
    className="text-blue-600 hover:underline"
  >
    onestopweddingdresses.com
  </a>{" "}
  or make a purchase from us.
</p>


         <div>
  <h2 className="text-xl font-semibold mb-2">1. Information We Collect</h2>
  <ul className="list-[numeric] ml-6 space-y-1">
    <li><strong>Personal Information:</strong></li>
    <ul className="list-disc ml-6 space-y-1">
      <li>Name</li>
      <li>Email address</li>
      <li>Phone number</li>
      <li>Billing and shipping address</li>
    </ul>
    
  <li>
  <strong>Payment Information:</strong>
  <ul className="list-disc ml-6 space-y-1">
    <li>
      We use secure third-party payment gateways such as{" "}
      <a
        href="https://razorpay.com"
        target="_blank"
        rel="noopener noreferrer"
        className="text-blue-600 hover:underline"
      >
        Razorpay
      </a>.
    </li>
    <li>We do not store your full card/UPI details on our servers.</li>
  </ul>
</li>

    <li>
  <strong>Technical Data:</strong>
  <ul className="list-disc ml-6 space-y-1">
    <li>IP address</li>
    <li>Browser type</li>
    <li>Device information</li>
    <li>Pages visited</li>
    <li>Time spent</li>
    <li>Collected via cookies or analytics tools to improve our website</li>
  </ul>
</li>

  </ul>
</div>


          <div>
            <h2 className="text-xl font-semibold mb-2">2. How We Use Your Information</h2>
            <p className="text-lg font-semibold mb-2">We use your information to:</p>
            <ul className="list-disc ml-6 space-y-1">
              <li>Process and fulfill your orders</li>
              <li>Communicate order status, shipping details, and support</li>
              <li>Respond to queries and customer service requests</li>
              <li>Improve website, products, and services</li>
              <li>Send promotional emails or offers (you can opt out at any
time)</li>
            </ul>
          </div>

          <div>
            <h2 className="text-xl font-semibold mb-2">3. Cookies & Tracking Technologies:</h2>
        <ul className="list-disc ml-6 space-y-1">  
             <li>We may use cookies, pixels, or similar technologies to:
</li>
  <ul className="list-disc ml-6 space-y-1">
    <li>Enhance your browsing experience</li>
    <li>Remember your preferences</li>
    <li>Analyze website traffic and performance</li>
  </ul>
  <li className="mt-2">
    You can control cookie usage from your browser settings, but some features may not work properly if cookies are disabled.
  </li>
</ul> 

          </div>

          <div>
            <h2 className="text-xl font-semibold mb-2">4. Sharing of Information</h2>
             <ul className="list-disc ml-6 space-y-1">
            <li>
  <p>We may share your information with
:</p>
  <ul className="list-disc ml-6 space-y-1">
    <li>
      Service providers: Courier partners,Payment gateways,Analytics tools
     
    </li>
    <li>Legal authorities, if required by law or to protect our rights.</li>
    
  </ul>
  <li>We do not sell your personal information to third parties.</li>
</li>
</ul>
          </div>

          <div>
            <h2 className="text-xl font-semibold mb-2">5. Data Security</h2>
             <ul className="list-disc ml-6 space-y-1">
  <li>We implement reasonable security measures to protect your data from unauthorized access, alteration, or disclosure.</li>
  <li>However, no method of transmission over the internet or electronic storage is 100% secure.</li>
</ul>

          </div>

          <div>
            <h2 className="text-xl font-semibold mb-2">6. Your Rights</h2>
            <p className="mb-2">Depending on applicable law, you may have rights to:
</p>
            <ul className="list-disc ml-6 space-y-1">
              <li>Access your personal data</li>
              <li>Request corrections or updates</li>
              <li>Request deletion (subject to legal/business requirements)</li>
              <li>Opt-out of marketing communications anytime</li>
            </ul>
              <p className="mb-2">To exercise these rights, please contact us.</p>
          </div>

          <div>
            <h2 className="text-xl font-semibold mb-2">7. Third-Party Links</h2>
          <ul className="list-disc ml-6 space-y-1">
  <li>Our website may contain links to third-party sites.</li>
  <li>We are not responsible for their privacy practices.</li>
  <li>Please review their policies separately.</li>
</ul>

          </div>

          <div>
            <h2 className="text-xl font-semibold mb-2">8. Changes to This Policy</h2>
            <p>We may update this Privacy Policy periodically. Any changes will
be posted on this page with an updated “Last updated on” date.
</p>
          </div>

          <div>
            <h2 className="text-xl font-semibold mb-2">9. Contact Us</h2>
            <p>For questions regarding this Privacy Policy or your personal data, contact us:</p>
            <p><strong>Phone:</strong> +91 83339 22444</p>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default PrivacyPolicy;
